import { Formik } from "formik";
import { FC } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "../../config/Api";
import Loading from "../../container/Loading";
import { addOrEditIndustryValidation } from "../../helper/constant";
import { IndustryInterface, PositionForSelect } from "../../helper/interface";
import useFetch from "../../hooks/useFetch";
import usePathName from "../../hooks/usePathName";
import { onEditIndustry } from "../../service/industry";
import AddOrEditIndustry from "./AddOrEditIndustry";
import { AlertTriangle, ArrowLeftCircle } from "react-feather";

const EditIndustry: FC = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { industryId = "" } = useParams();

    const { res, loading, error } = useFetch<IndustryInterface>(`${api.admin.getIndustry}/${industryId}`);

    usePathName([
        { pathName: "Industry", href: "/position" },
        { pathName: "Edit", href: `/industry/edit/${industryId}` },
        { pathName: `${industryId}`, href: `/industry/edit/${industryId}` },
    ]);

    const onSubmitIndustry = (values: IndustryInterface) => {
        onEditIndustry({ ...values, industryId: +industryId }, navigate, dispatch);
    };

    const oldVal: IndustryInterface | undefined = res?.data
        ? {
            ...res.data,
            positions: (res?.data?.positionList ?? [])
                .map((ele) => ele.positionDetails)
                .filter(Boolean) as PositionForSelect[],
        }
        : undefined;

    return (
        <div className="intro-y box py-10 sm:py-10 mt-5">
            <div className="flex w-full items-center">
                <div className="flex-2 ml-4">
                    <ArrowLeftCircle className="cursor-pointer text-primary" onClick={() => navigate("/position")} />
                </div>
                <div className="flex-1 font-medium text-center text-lg -ml-2">Edit industry</div>
            </div>
            <div className="px-5 sm:px-20 mt-10 pt-10 border-t border-slate-200/60 dark:border-darkmode-400">
                {error ? (
                    <div className="alert alert-danger mt-6 show flex items-center mb-2" role="alert">
                        <AlertTriangle className="w-6 h-6 mr-2" /> {error}
                    </div>
                ) : loading ? (
                    <Loading />
                ) : oldVal ? (
                    <Formik initialValues={oldVal} validationSchema={addOrEditIndustryValidation} onSubmit={onSubmitIndustry}>
                        {(props) => <AddOrEditIndustry {...props} />}
                    </Formik>
                ) : null}
            </div>
        </div>
    );
};

export default EditIndustry;
